import classNames from 'classnames';
import { FlexContainer, Txt, View } from 'components/index';
import { DateTime } from 'luxon';
import styles from './TimeLine.module.scss';

/**
 * TimeLine
 *
 * @return {JSX.Element}
 */
const TimeLine = ({ className, dateStart, dateEnd }) => {
  let width = '';

  if (dateStart && dateEnd) {
    const startTs = dateStart.getTime();
    const endTs = dateEnd.getTime();
    const nowTs = Date.now();

    const length = endTs - startTs;
    const progress = nowTs - startTs;

    if (progress > 0) {
      width = `${(progress / length) * 100}%`;
    }
  }

  const luxonStartDate = DateTime.fromJSDate(dateStart);
  const luxonEndDate = DateTime.fromJSDate(dateEnd);

  return (
    <FlexContainer
      className={classNames(styles.TimeLine, className, TimeLine.displayName)}
      alignCenter
      gapHalf
    >
      <View className={styles.Date}>
        <Txt>
          {luxonStartDate.toLocaleString({
            month: 'long',
            day: 'numeric',
          })}
        </Txt>
        <Txt>
          {luxonStartDate.toLocaleString({
            year: 'numeric',
          })}
        </Txt>
      </View>
      <View className={styles.DateDivider}>
        <View className={styles.DateProgressValue} style={{ width }} />
      </View>
      <View className={styles.Date}>
        <Txt>
          {luxonEndDate.toLocaleString({
            month: 'long',
            day: 'numeric',
          })}
        </Txt>
        <Txt>
          {luxonEndDate.toLocaleString({
            year: 'numeric',
          })}
        </Txt>
      </View>
    </FlexContainer>
  );
};

TimeLine.displayName = 'TimeLine';

export default TimeLine;
